export class Slot {
    name:string=""
    source :string="template"
    valuetype:string=""
    value:string=""
    boldManager:string="A"
    params: Slot[]=[]
}
